/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const FieldRecordCounts = core.serialization.object({
    total: core.serialization.number(),
    valid: core.serialization.number(),
    error: core.serialization.number(),
    empty: core.serialization.number(),
});
